import { render, staticRenderFns } from "./TenantDashboard.vue?vue&type=template&id=31043340&scoped=true&"
import script from "./TenantDashboard.vue?vue&type=script&lang=js&"
export * from "./TenantDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TenantDashboard.vue?vue&type=style&index=0&id=31043340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31043340",
  null
  
)

export default component.exports